<template>
    <div class="board-container">
        <div class="board-search-wrap">
            <v-row class="row--xs search--primary">
                <v-spacer />
                <v-col class="select-box" cols="12" md="auto">
                    <v-select v-model="filter.searchKey" :items="searchKeys" class="v-input--small w-100 w-md-120px" outlined hide-details />
                </v-col>
                <v-col class="search-box" md="auto">
                    <v-text-field v-model="filter.searchValue" class="v-input--small w-100 w-md-260px" outlined hide-details placeholder="검색어를 입력하세요." />
                </v-col>
                <v-col class="search-btn" cols="auto" @click="search">
                    <v-btn dark color="grey">검색</v-btn>
                </v-col>
            </v-row>
        </div>

        <table class="board-list">
            <thead class="d-lg-table-header">
                <tr>
                    <th style="width:58%;" class="board-list__txt">제목</th>
                    <th style="width:16%;" class="board-list__txt">작성자</th>
                    <th style="width:16%;" class="board-list__txt">작성일</th>
                    <th style="width:10%;" class="board-list__txt">조회</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="notification in notifications" :key="notification._id" @click="$router.push(`/service/notice/${notification._id}`)">
                    <td class="board-list__tit">
                        <div class="text-truncate">
                            <span>
                                {{ notification?.subject }}
                            </span>
                        </div>
                    </td>
                    <td class="board-list__txt">
                        관리자
                    </td>
                    <td class="board-list__txt">
                        {{ $dayjs(notification?.createdAt).format("YYYY-MM-DD") }}
                    </td>
                    <td class="board-list__txt">
                        {{ notification?.viewCount }}
                    </td>
                </tr>
            </tbody>
        </table>

        <pagination-component v-model="page" :count="pageCount" @input="search"></pagination-component>
    </div>
</template>

<script>
import api from "@/api";
import PaginationComponent from "@/components/client/control/pagination-component.vue";
import { mdiAlertCircleOutline } from "@mdi/js";
export default {
    components: {
        PaginationComponent,
    },
    props: {
        value: { type: String, default: null },
    },
    data() {
        return {
            mdiAlertCircleOutline,

            filter: {
                searchKey: "subject",
                searchValue: null,
            },

            page: 1,
            pageCount: 0,
            limit: 10,

            fixed: [],
            notifications: [],

            searchKeys: [
                { text: "제목", value: "subject" },
                { text: "내용", value: "content" },
            ],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            await this.search();
        },
        async search() {
            // this.$router.push({
            //     query: Object.assign({}, this.query, { page: this.page }),
            // });

            var { summary, notifications } = await api.v1.center.notifications.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit,
                },
                params: this.filter,
            });

            this.notifications = notifications;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },
    },
};
</script>
